export const actionBarSx = (theme) => ({
  backgroundColor: theme.palette.background.secondary,
  position: 'fixed',
  bottom: 0,
  width: '100%',
  maxWidth: '1100px',
  height: 'auto',
  paddingTop: '4px',
  paddingBottom: 'env(safe-area-inset-bottom, 0)',
  '& .Mui-selected': {
    '& .MuiBottomNavigationAction-label': {
      color: theme.palette.tertiary.main,
      fontSize: '12px',
    },
    '& .MuiSvgIcon-root, & .MuiBottomNavigationAction-label': {
      color: theme.palette.tertiary.main,
    },
  },
});

export const actionBarActionSx = (theme) => ({
  color: theme.palette.secondary.main,
  '&:focus, &:hover': {
    color: theme.palette.tertiary.main,
  },
  '.MuiBottomNavigationAction-label': {
    fontSize: '12px',
  },
});
